<template>
  <div>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-clipboard-file-outline
          </v-icon>
          排出事業者
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-title />
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="5">
                      <v-text-field v-model="subscriber_number" dense hide-details label="加入者番号" clearable
                        persistent-placeholder />
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field v-model="edi_usage_key" dense hide-details label="EDI確認キー" clearable
                        persistent-placeholder />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="5">
                      <v-text-field v-model="name" dense hide-details label="加入者名" clearable persistent-placeholder />
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field v-model="requester_name" dense hide-details label="申請者名" clearable persistent-placeholder />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="5">
                      <v-text-field
                        v-model="from_subscriber_number"
                        clearable
                        dense
                        hide-details label="加入者番号（開始）"
                        persistent-placeholder
                      >
                        <template v-slot:append-outer>〜</template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-text-field
                        v-model="to_subscriber_number"
                        clearable
                        dense
                        hide-details label="加入者番号（終了）"
                        persistent-placeholder
                      />

                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="5">
                      <v-select v-model="jwnet_price_plan" clearable :items="jwnet_price_plans" label="JWNET料金プラン"
                        hide-details="auto" persistent-placeholder />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    &nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <!-- ボタン -->
    <v-row>
      <v-col cols="2" class="text-left">
        <h4>
          {{ total_count }} 件
        </h4>
      </v-col>

      <v-col cols="10" class="text-right">
        <!-- TODO 出力履歴ボタン追加 -->
        <template>
          <output-reservation-dialog
            section="admin_dxe_emission"
            button-class="d-inline-block mr-3"
            :enable-blink="blinkingButton"
            @stopBlinkCallback="blinkingButton = false"
          />
        </template>
        &nbsp;

        <template v-if="$vuetify.breakpoint.mdAndUp">
          <v-btn color="info" @click="exportButtonClickEvent">
            <v-icon>mdi-file-download-outline</v-icon>&nbsp;CSV出力
          </v-btn>
          &nbsp;
          <v-btn color="info" @click="exportCancelCsvTargetButtonClickEvent">
            <v-icon>mdi-file-download-outline</v-icon>&nbsp;解約対象CSV出力
          </v-btn>
          &nbsp;
          <v-btn color="info" @click="importButtonClickEvent">
            <v-icon>mdi-file-upload-outline</v-icon>&nbsp;CSV取込
          </v-btn>
        </template>
        <template v-else>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="info" dark v-bind="attrs" v-on="on">
                CSVファイル
                <v-icon small>
                  mdi-file-outline
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="exportButtonClickEvent">
                <v-list-item-title>
                  CSV出力
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="exportCancelCsvTargetButtonClickEvent">
                <v-list-item-title>
                  解約対象CSV出力
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="importButtonClickEvent">
                <v-list-item-title>
                  CSV取込
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        &nbsp;
        <v-btn color="info" @click="addButtonClickEvent">
          <v-icon>mdi-plus</v-icon>&nbsp;排出事業者の追加
        </v-btn>
      </v-col>
    </v-row>
    <!-- /ボタン -->

    <v-row>
      <v-col>
        <v-card class="rounded-card">
          <v-card-text>
            <v-data-table :headers="tableHeaders" :items="emissions" :items-per-page="-1" disable-pagination disable-sort
              hide-default-footer>
              <template v-slot:[`item.name`]="{ item }">
                <span v-if="item.status === 'pending'">
                  <v-icon class="red--text">mdi-exclamation-thick</v-icon>
                </span>
                <span :title="item.name">{{ item.name | truncate }}</span>
              </template>

              <template v-slot:[`item.first_requester`]="{ item }">
                {{ item.first_requester
                }}<span v-if="item.requester_count > 0"
                  >&emsp;全&nbsp;{{ item.requester_count }}件</span>
              </template>

              <template v-slot:[`item.jwnet_price_plan`]="{ item }">
                {{ item.jwnet_price_plan | jwnet_price_plan }}
              </template>

              <template v-slot:[`item.created_at`]="{ item }">
                {{ item.created_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.editable`]="{ item }">
                <v-btn v-if="$vuetify.breakpoint.mdAndUp" icon color="info darken-2" @click="showButtonClickEvent(item)">
                  <v-icon>mdi-file-document-outline</v-icon>
                </v-btn>
                <v-btn v-else text color="info" @click="showButtonClickEvent(item)">
                  参照する
                </v-btn>
                <v-btn v-if="$vuetify.breakpoint.mdAndUp" color="info darken-2" icon @click="editButtonClickEvent(item)">
                  <v-icon>mdi-note-edit</v-icon>
                </v-btn>
                <v-btn v-else text color="info" @click="editButtonClickEvent(item)">
                  編集する
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row v-if="hasResult" dense>
      <v-col>
        <v-pagination v-model="page" :length="pagination.total_pages" :total-visible="totalVisible" circle
          prev-icon="mdi-menu-left" next-icon="mdi-menu-right" @input="changePage" />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <!-- 解約対象CSV出力ダイアログ -->
    <v-dialog v-model="cancelTargetDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="text-h6">
          解約対象CSV出力
        </v-card-title>
        <v-card-text>
          <v-form v-model="cancelTargetFormValid">
            <v-row justify="center">
              <v-col cols="10">
                <v-text-field
                  v-model.number="unregisteredMonths"
                  label="マニフェスト未登録月"
                  type="number"
                  suffix="ヶ月"
                  step="1"
                  min="1"
                  max="48"
                  :rules="[
                    v => !!v || 'マニフェスト未登録月は必須です',
                    v => !isNaN(v) && v >= 1 && v <= 48 || '1〜48の値を入力してください',
                  ]"
                  hint="指定した月数以上マニフェストが登録されていない排出事業者を出力します"
                  persistent-hint
                  required
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn 
            @click="cancelTargetDialog = false"
          >
            閉じる
          </v-btn>
          <v-btn 
            color="primary" 
            @click="executeCancelCsvExport" 
            :disabled="!cancelTargetFormValid"
          >
            実行
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- /解約対象CSV出力ダイアログ -->

    <confirm ref="confirm" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Confirm from '../../../../components/Confirm'
import DownloadMixin from '../../../../mixins/download-mixin'
import OutputReservationDialog from "@/admin/components/OutputReservationDialog.vue";
export default {
  name: 'AdminMasterEmissionIndex',
  components: {
    Confirm,
    OutputReservationDialog,
  },
  mixins: [
    DownloadMixin,
  ],
  props: {},
  data() {
    return {
      page: 1,
      totalVisible: 7,
      total_count: null,
      name: null,
      subscriber_number: null,  // 加入者番号
      from_subscriber_number: null,
      to_subscriber_number: null,
      edi_usage_key: null,
      requester_name: null,
      jwnet_price_plan: null,
      blinkingButton: false,
      cancelTargetDialog: false,  // 解約対象CSV出力ダイアログ表示状態
      unregisteredMonths: 24,  // マニフェスト未登録月（デフォルト24ヶ月）
      cancelTargetFormValid: false,  // 解約対象CSV出力フォームの妥当性
      tableHeaders: [
        { value: 'subscriber_number', text: '加入者番号' },
        { value: 'edi_usage_key', text: 'EDI利用確認キー' },
        { value: 'name', text: '加入者名' },
        { value: 'first_requester', text: '申請者名' },
        { value: 'jwnet_price_plan', text: 'JWNET料金プラン' },
        { value: 'created_at', text: '作成日時' },
        { value: 'editable', text: '参照', align: 'end' },
      ],
      emissions: [],
      jwnet_price_plans: [],
    }
  },
  computed: {
    ...mapState('AdminMasterEmission', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('AdminMasterEmission', [
      'hasResult'
    ]),
  },
  watch: {
    emissionName(newVal) {
      this.saveCondition({ name: newVal })
    },
    emissinSubscriberNumber(newVal) {
      this.saveCondition({ subscriber_number: newVal })
    },
    emissinEdiIdentifyKey(newVal) {
      this.saveCondition({ edi_identify_key: newVal })
    },
    emissionRequesterName(newVal) {
      this.saveCondition({ requester_name: newVal })
    },
  },
  created() {

    if (this.$route.params.resetCondition) {
      this.resetCondition()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    
    this.from_subscriber_number = this.searchCondition.from_subscriber_number
    this.to_subscriber_number = this.searchCondition.to_subscriber_number
    this.jwnet_price_plan = this.searchCondition.jwnet_price_plan

    this.name = this.searchCondition.name
    this.subscriber_number = this.searchCondition.subscriber_number
    this.edi_usage_key = this.searchCondition.edi_usage_key
    this.requester_name = this.searchCondition.requester_name
    this.page = this.pagination.current_page
    this.searchEmissions()
  },
  methods: {
    ...mapActions('AdminMasterEmission', {
      fetchEmissions: 'index',
      saveCondition: 'saveCondition',
      resetCondition: 'resetState',
      resetPagination: 'resetPagination',
    }),
    ...mapActions('AdminMasterEmissionOutputReservation', {
      outputReserve: 'create'
    }),
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent() {
      this.page = 1
      this.searchEmissions()
    },
    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent() {
      this.$router.push({ name: 'AdminMasterEmissionNew' })
    },
    /**
     * 参照ボタンクリックイベント
     */
    showButtonClickEvent(item) {
      this.$router.push({ name: 'AdminMasterEmission', params: { id: item.id } })
    },
    /**
     * 編集ボタンクリックイベント
     */
    editButtonClickEvent(item) {
      this.$router.push({ name: 'AdminMasterEmissionEdit', params: { id: item.id } })
    },
    changePage() {
      this.searchEmissions()
    },
    /**
     * 排出事業者検索
     */
    searchEmissions() {
      let params = this.buildParam('json')
      this.fetchEmissions(params).then((content) => {
        this.emissions = content.emissions

        this.jwnet_price_plans = content.jwnet_price_plans

        this.total_count = content.pagination.total_count
      })
    },

    /**
     * CSV出力ボタン クリックイベント
     */
    exportButtonClickEvent() {
      // 検索条件取得
      let params = this.buildParam('csv')

      // params['output_type'] = type

      // 出力予約を作成
      this.outputReserve({ conditions: params }).then(() => {
        this.blinkingButton = true;  // 出力履歴ボタン点滅
      })
    },
    /**
     * 解約対象CSV出力ボタン クリックイベント
     */
    exportCancelCsvTargetButtonClickEvent() {
      // ダイアログを開く
      this.cancelTargetDialog = true
    },

    /**
     * 解約対象CSV出力実行
     */
    executeCancelCsvExport() {
      // ダイアログを閉じる
      this.cancelTargetDialog = false
      
      // 検索条件取得
      let params = this.buildParam('csv')
      // 
      params['cancel_target'] = true
      params['unregistered_months'] = this.unregisteredMonths
      // 出力予約を作成
      this.outputReserve({ conditions: params }).then(() => {
        this.blinkingButton = true;  // 出力履歴ボタン点滅
      })
    },

    /**
     * CSV取込ボタン クリックイベント
     */
     importButtonClickEvent() {
      this.$router.push({name: 'AdminMasterEmissionCsvImport'})
    },

    /*パラメータ設定 */
    buildParam(format) {
      return {
        name: this.name,
        subscriber_number: this.subscriber_number,
        from_subscriber_number: this.from_subscriber_number,
        to_subscriber_number: this.to_subscriber_number,
        edi_usage_key: this.edi_usage_key,
        requester_name: this.requester_name,
        jwnet_price_plan: this.jwnet_price_plan,
        page: this.page,
        format: format
      }
    },

  }
}
</script>

<style scoped lang="scss">
.panel-header-color {
  color: #0D74BA !important;

  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;

      &::before {
        color: #0D74BA !important;
      }
    }
  }
}

.panel-selectable {
  background-color: #DCE7EB;
}
</style>
